module.exports = __webpack_public_path__ + "img/save_sign.8c7a12c3.svg";